export default __webpack_public_path__ + "static/light_bulb_w.3e3f9f76706ec941bcbe027544646420.png";